module.exports = __webpack_public_path__ + "static/img/application4-5.a33895b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/application/application4-5.jpg
// module id = kX0O
// module chunks = 0